import { render, staticRenderFns } from "./gift-item.vue?vue&type=template&id=3548a294&"
import script from "./gift-item.vue?vue&type=script&lang=js&"
export * from "./gift-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports